import { Fragment } from "react"

export const splitText = text => {
  if (!text) return

  const textArr = text?.split("endl")
  const length = textArr.length

  return textArr.map((text, index) => (
    <Fragment key={index}>
      {text}
      {length - 1 > index && <br />}
    </Fragment>
  ))
}

export const menuItems = ["Acasa", "Blog", "Despre noi", "Contact"]

export const servicesPaths = [
  "/aplicatii-mobile",
  "/aplicatii-web",
  "/magazin-online",
  "/promovare-online",
  "/copywriting",
  "/strategie-de-marketing",
]
